import React from 'react';
import { cn } from '../../lib/utils';

export interface ProgressBarProps {
  value: number; // 0-100
  color?: 'teal' | 'blue' | 'amber' | 'purple' | 'green';
  variant?: 'teal' | 'blue' | 'amber' | 'purple' | 'green'; // Alias for color
  className?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ 
  value, 
  color = 'blue',
  variant,
  className 
}) => {
  const activeColor = variant || color;
  const colors = {
    teal: 'bg-teal-600',
    blue: 'bg-blue-600',
    amber: 'bg-amber-600',
    purple: 'bg-purple-600',
    green: 'bg-emerald-600',
  };

  return (
    <div className={cn('h-2 bg-gray-200 rounded-full overflow-hidden', className)}>
      <div
        className={cn('h-full rounded-full transition-all duration-500', colors[activeColor])}
        style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
      />
    </div>
  );
};
